// Select elements outside of the event listener to avoid querying them on every DOMContentLoaded event
const intro = document.querySelector('.intro');
const logoSpan = document.querySelectorAll('.logoS');
const button = document.getElementById('buttonMy');

// Wrap your code inside an IIFE (Immediately Invoked Function Expression) to avoid polluting the global scope
(() => {
    window.addEventListener('DOMContentLoaded', () => {
        // Disable scrolling on the body
        document.body.style.overflow = 'hidden';
        disableScroll();

        // Use a single setTimeout for sequential animations
        setTimeout(() => {
            logoSpan.forEach((span, idx) => {
                setTimeout(() => {
                    span.classList.add('active');
                }, (idx + 1) * 400);
            });

            setTimeout(() => {
                logoSpan.forEach((span, idx) => {
                    setTimeout(() => {
                        span.classList.remove('active');
                        span.classList.add('fade');
                    }, (idx + 1) * 50);
                });

                setTimeout(() => {
                    // Use CSS transitions instead of directly setting height for smoother animation
                    intro.style.transition = 'height 0.5s ease-in-out';
                    intro.style.height = '0px';

                    // Re-enable scrolling on the body
                    document.body.style.overflow = '';
                    document.body.style.overflowX = 'hidden';
                    enableScroll();

                    // Show images one by one with delay after intro
                    const imagesDelay = document.querySelectorAll('.delayAppear');
                    imagesDelay.forEach((image, index) => {
                        setTimeout(() => {
                            image.style.transition = 'opacity 0.5s ease-in-out';
                            image.style.opacity = '1';
                            if (index === imagesDelay.length - 1) {
                                button.style.display = 'inline-flex';
                            }
                        }, (index + 1) * 1000); // 1000 milliseconds delay (1 second)
                    });
                }, logoSpan.length * 50 + 500); // Adjust timing to ensure all animations complete before proceeding
            }, logoSpan.length * 400 + 1000); // Adjust timing to ensure all animations complete before proceeding
        });
    });
})();

// Function to disable scrolling on touch devices
function disableScroll() {
    document.addEventListener('touchmove', preventDefault, { passive: false });
}

// Function to enable scrolling on touch devices
function enableScroll() {
    document.removeEventListener('touchmove', preventDefault);
}

// Function to prevent default touch event behavior (i.e., scrolling)
function preventDefault(e) {
    e.preventDefault();
}
